import { render, staticRenderFns } from "./ReferralTeacherBody.vue?vue&type=template&id=c70fc27c&scoped=true&"
import script from "./ReferralTeacherBody.vue?vue&type=script&lang=js&"
export * from "./ReferralTeacherBody.vue?vue&type=script&lang=js&"
import style0 from "./ReferralTeacherBody.vue?vue&type=style&index=0&id=c70fc27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70fc27c",
  null
  
)

export default component.exports